var map = {
	"./code-css-lg.webp": "c7de",
	"./code-html-lg.webp": "f586",
	"./code-jquery-lg.webp": "66f3",
	"./code-js-lg.webp": "64be",
	"./code-vue-lg.webp": "76f9",
	"./sw-face-lg.webp": "6b8d",
	"./sw-logo-lg.webp": "3ff5",
	"./sw-ps-lg.webp": "d642"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9020";